exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-control-next[data-v-44a0e318],.carousel-control-prev[data-v-44a0e318]{filter:invert(100%)}.additional-item-price-box[data-v-44a0e318]{display:block}.additional-item-price-box[data-v-44a0e318]:after{content:\"+\"}.additional-item-price-box[data-v-44a0e318]:last-child:after{content:\"\"}", ""]);

// exports
